import "/__w/1/s/BotFramework-WebChat/packages/component/src/Attachment/Text/TextContent.module_built.css";
const classes = {"text-content--is-markdown":"wOVnR0W_text-content--is-markdown","text-content__markdown":"wOVnR0W_text-content__markdown","text-content":"wOVnR0W_text-content","text-content__generated-badge":"wOVnR0W_text-content__generated-badge","text-content__activity-actions":"wOVnR0W_text-content__activity-actions","text-content__open-in-new-window-icon":"wOVnR0W_text-content__open-in-new-window-icon"}
export default classes

const _text_content__is_markdown0 = classes["text-content--is-markdown"]
export { _text_content__is_markdown0 as "text-content--is-markdown" }

const _text_content__markdown0 = classes["text-content__markdown"]
export { _text_content__markdown0 as "text-content__markdown" }

const _text_content0 = classes["text-content"]
export { _text_content0 as "text-content" }

const _text_content__generated_badge0 = classes["text-content__generated-badge"]
export { _text_content__generated_badge0 as "text-content__generated-badge" }

const _text_content__activity_actions0 = classes["text-content__activity-actions"]
export { _text_content__activity_actions0 as "text-content__activity-actions" }

const _text_content__open_in_new_window_icon0 = classes["text-content__open-in-new-window-icon"]
export { _text_content__open_in_new_window_icon0 as "text-content__open-in-new-window-icon" }
